// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"e9a19127","651":"481e78a5"}[chunkId] + ".chunk.js";
};